<template>
    <div>
      <div class="cs-head">
        <div @click="jumpToProjectListPage" class="head-logo">
            <img src="../assets/images/web_top_logo_white.png" width="50">
        </div>
        <div class="head-pro" v-if="needShow">
            <div class="sel-pro">
                <div>
                    <span>{{projectName}}</span>
                    <i class="el-icon-arrow-down"></i>
                </div>
                <div class="pro-content">
                    <div class="arrow">
                        <img src="../assets/images/dialog_bg_arrow.png" width="18">
                    </div>
                    <div class="pro-wrap">
                        <div class="pro-input">
                            <el-input v-model="searchProjectName"
                                    :placeholder="$store.state.i18n.searchProject[$store.state.CN_EN]"
                                    prefix-icon="el-icon-search">
                            </el-input>
                        </div>
                        <ul class="pro-list">
                            <li @click="projectChange(index)" ref="dataNum" :data-name="project.projectName" :data-id="project.projectId" v-for="(project,index) in projectList" :key="project.projectId">
                                {{project.projectName}}<span v-if="project.projectState != null && project.projectState != undefined && project.projectState == 2">
                                {{$store.state.i18n.notNoticeForHead[$store.state.CN_EN]}}
                            </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div @click="addProjectEvent" class="btn-add">
                <i class="el-icon-plus"></i>
                <span>{{$store.state.i18n.createProject[$store.state.CN_EN]}}</span>
            </div>
        </div>
        <div class="head-user">
            <div class="info info-language">
                <img src="../assets/images/top_ico_language.png" width="26">
                <div class="language">
                    <el-select v-model="selectLanguage" :placeholder="$store.state.i18n.choose[$store.state.CN_EN]">
                        <el-option label="简体中文" value="0"></el-option>
                        <el-option label="English" value="1"></el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block;" v-if="isNeedShowForAboutMe">
                <div class="line">|</div>
                <a href="aboutMe.html?first&1" target="_blank" class="about-me">
                    <img src="../assets/images/top_ico_news.png" width="20"/>
                    <span>{{$store.state.i18n.aboutMe[$store.state.CN_EN]}}</span>
                </a>
            </div>
            <!--<div @click="jumpToMessagePage" class="info">
                <img src="../assets/images/top_ico_news.png" width="20">
                <span class="text">{{$store.state.i18n.relatedToMe[$store.state.CN_EN]}}</span>
                <span v-if="totalCount != null && totalCount > 0" class="num">{{totalCount | valNumberMaxHandler}}</span>
            </div>-->
            <div class="line">|</div>
            <div class="person">
                <div class="top-user">
                    <div v-if="headImagePath == null || headImagePath.length == 0" class="user-img bg">{{firstLetter}}</div>
                    <!--有头像显示头像-->
                    <img v-else :src="headImagePath" class="user-img">
                    <span>{{memberName}}</span>
                    <img src="../assets/images/my_plan_vicon_gary_small.png" width="16" class="icon" v-if="isInValid == true">
                    <img src="../assets/images/my_plan_vicon_yellow_small.png" width="16" class="icon" v-if="isInValid == false">
                </div>
                <div class="person-content">
                    <div class="arrow">
                        <img src="../assets/images/dialog_bg_arrow.png" width="18">
                    </div>
                    <ul class="person-list">
                        <li>
                            <div class="drop-user">
                                <div v-if="headImagePath == null || headImagePath.length == 0" class="user-img bg">{{firstLetter}}</div>
                                <!--有头像显示头像-->
                                <img v-else :src="headImagePath" class="user-img">
                                <img src="../assets/images/my_plan_vicon_gary_small.png" width="16" class="icon" v-if="isInValid == true">
                                <img src="../assets/images/my_plan_vicon_yellow_small.png" width="16" class="icon" v-if="isInValid == false">
                            </div>
                            <div class="drop-user-info">
                                <div class="name">{{memberName}}</div>
                                <div class="email">{{email}}</div>
                            </div>
                        </li>
                        <li @click="jumpToPersonalCenter('third')">
                            <img src="../assets/images/my_plan_vicon_gary_big.png" class="icon-pro" v-if="isInValid == null || isInValid == undefined || isInValid == true">
                            <img src="../assets/images/my_plan_vicon_yellow_big.png" class="icon-pro" v-else>
                            <div class="drop-pro">
                                <div class="name" v-if="isBuyPackage == 1">{{productName | valNullHandler($store.state.i18n.customizedProduct[$store.state.CN_EN])}}</div>
                                <div class="name" v-else>{{$store.state.i18n.package[$store.state.CN_EN]}} --</div>
                                <div class="time" v-if="isBuyPackage == 1">{{validDateMaxStr | valNullHandler}} {{$store.state.i18n.invalid[$store.state.CN_EN]}}</div>
                                <div class="time" v-else>{{$store.state.i18n.myPackageInvalidDate[$store.state.CN_EN]}} --</div>
                            </div>
                            <div class="drop-btn" v-if="isBuyPackage == null || isBuyPackage == 0" @click="jumpToIndexPay">{{$store.state.i18n.myPackageBuy[$store.state.CN_EN]}}</div>
                            <div class="drop-btn" v-else @click="jumpToIndexPay">{{$store.state.i18n.myPackageChange[$store.state.CN_EN]}}</div>
                        </li>
                        <li @click="jumpToPersonalCenter('first')">
                            <img src="../assets/images/top_ico_me.png" alt="">
                            <span>{{$store.state.i18n.basicInfo[$store.state.CN_EN]}}</span>
                        </li>
                        <li @click="jumpToPersonalCenter('second')">
                            <img src="../assets/images/top_ico_setting.png" alt="">
                            <span>{{$store.state.i18n.accountSet[$store.state.CN_EN]}}</span>
                        </li>
                        <li @click="logout">
                            <img src="../assets/images/top_ico_logout.png" alt="">
                            <span>{{$store.state.i18n.exit[$store.state.CN_EN]}}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="clearfix"></div>
      </div>
      <add-project-alert ref="addProjectAlert"></add-project-alert>
    </div>
</template>
<script>
	import Vue from 'vue'
    import VueCookies from 'vue-cookies'
	//import { Input } from 'element-ui';
	//Vue.use( Input )
    // 引用全局方法
    import globalFunctions from '../assets/js/common/GlobalFunction.js'

    //引入全局方法文件中本页面需要用到的方法
    Vue.prototype.$byUrlInitValue = globalFunctions.$byUrlInitValue
    //Cookie
    Vue.use(VueCookies)

	import AddProjectAlert from "../components/AddProjectAlert.vue";

    export default {
        name:"Head",
		components	: { AddProjectAlert },
        data() {
            return {
                //接口版本号
                interfaceVersion:19000101,

                needShow:true,
                projectName:null,
                projectNameTemp:null,
                projectList:[],
                searchProjectName:null,

                //登录用户信息
                isNeedShowForAboutMe:false,
                memberName:null,
                headImagePath:null,
                firstLetter:null,
                email:null,
                totalCount:1000,//TODO 待需求完善后，再开发（当前存在一种情况“在项目列表，用户未选择项目时，无法统计，因为角色是和项目关联的”）
                selectLanguage: this.$store.state.CN_EN+"",

                //我的套餐
                isBuyPackage:null,
                productName:null,
                validDateMaxStr:null,
                isInValid:false,//套餐到期
            }
        },
        mounted(){
            //从Cookie中获取信息
            this.memberName = localStorage.getItem("memberName");
            this.headImagePath = localStorage.getItem("headImagePath");
            this.firstLetter = localStorage.getItem("firstLetter");
            this.email = localStorage.getItem("email");
            if (this.email && this.email.indexOf("@chisalsoft.com") >= 0) {
                this.isNeedShowForAboutMe = true
            }

            //根据Url中的参数，初始化数据
            this.$byUrlInitValue("&", this, ["projectId", "projectNameTemp"]);
            if(this.projectId == null || this.projectId == 'null' || this.projectId.length == 0)
            {
                this.projectId = ''
                this.projectName = this.$store.state.i18n.projects[this.$store.state.CN_EN]
            }
            else
            {
                this.projectName = this.projectNameTemp
            }

            if(this.projectName == null || this.projectName == 'null' || this.projectName.length == 0)
            {
                this.projectName = this.$store.state.i18n.projects[this.$store.state.CN_EN]
            }

            //项目列表页面，隐藏头部组件中的项目下拉选和添加项目
            let pageName = window.location.pathname.substring(1);
            if(pageName != null && pageName.length > 0 && pageName.indexOf(".html") < 0) pageName += ".html";
            if(pageName == 'projectList.html' || pageName == 'message.html' || pageName == 'aboutMe.html') this.needShow = false;

            //console.info(this.projectId);
            //console.info(this.projectName);

            //initData
            this.getProjectMemberRelationList()
            //获取与我相关数量
            this.getStatisticsCountForMe()
            //获取我的套餐基本信息
            this.getProductMemberDetailForHead()
        },
        methods : {
            stopBubble(e){
                if ( e && e.stopPropagation ){
                    e.stopPropagation();
                }

                else{
                    window.event.cancelBubble = true;
                }
            },
            getForm:getForm,
            //加载项目数据
            getProjectMemberRelationList : getProjectMemberRelationList,
            projectChange:projectChange,
            jumpToProjectListPage:jumpToProjectListPage,
            jumpToMessagePage:jumpToMessagePage,
            jumpToPersonalCenter:jumpToPersonalCenter,
            logout(){
                globalFunctions.logout(this)
            },
			addProjectEvent() {
				this.$refs.addProjectAlert.show()
			},
            startRequest(){

            },
            getStatisticsCountForMe:getStatisticsCountForMe,
            getProductMemberDetailForHead:getProductMemberDetailForHead,
            jumpToIndexPay:jumpToIndexPay,
        },
        watch : {
            selectLanguage: function(val){
                this.$store.commit('setLanguage', val);
                localStorage.setItem("selectLanguage", val);
                // 设置语言
                if(this.$i18n != null)
                {
                    if("1" == val)
                    {
                        this.$i18n.locale = 'en';
                    }
                    else
                    {
                        this.$i18n.locale = 'zh';
                    }
                }

                window.location.reload();
            },
            'searchProjectName': function () {
                //console.log(this.searchProjectName)
                this.getProjectMemberRelationList()
            }
        }
    }

    function getForm() {
        return {
            interfaceVersion:this.interfaceVersion,
        }
    }

    //加载我的项目列表
    function getProjectMemberRelationList() {
        //console.info(11111)
        let model = {
            interfaceVersion:19000101,
            pageNumber:(this.searchProjectName == null || this.searchProjectName == undefined || this.searchProjectName.length == 0) ? 0 : 1,
            countPerPage:20,
            keyword:this.searchProjectName,
        }
        this.$api.post('/smProjectListForMeForSelect.smhtml', model, jsonObj => {
            this.projectList = jsonObj.projectList;
            // if(this.projectList != null && this.projectList.length > 0)
            // {
            //     // this.projectName=this.projectList[19].projectName;
            //     // this.projectId=this.projectList[19].projectId;
            //     // // console.info(this.projectList)
            //     //
            //     // this.$store.commit('setProjectName', this.projectName);
            //     // this.$store.commit('setProjectId', this.projectId);
            // }
            // this.$message.success(jsonObj.info);
            // console.log(jsonObj);
        },jsonObj => {
            // console.log(jsonObj);
            this.$message.error(jsonObj.info);
        })
    }

    //项目切换
    function projectChange(index)
    {
        this.projectName=this.projectList[index].projectName;
        this.projectId=this.projectList[index].projectId;
        //将projectName和projectId存在sessionStorage中
        // this.$cookie.set('projectName', this.projectName, 1);
        // this.$cookie.set('projectId', this.projectId, 1);

        //获取当前路径
        let pageName = window.location.pathname.substring(1);
        if(pageName != null && pageName.length > 0 && pageName.indexOf(".html") < 0) pageName += ".html";
        if(pageName != null && (pageName.endsWith("Detail.html") || pageName.endsWith("Edit.html") || pageName.endsWith("Update.html")))
        {
            if(pageName.endsWith("Detail.html")) pageName = pageName.substring(0,pageName.lastIndexOf("Detail.html"));
            if(pageName.endsWith("Edit.html")) pageName = pageName.substring(0,pageName.lastIndexOf("Edit.html"));
            if(pageName.endsWith("Update.html")) pageName = pageName.substring(0,pageName.lastIndexOf("Update.html"));

            // console.info(pageName)
            window.location.href=encodeURI(pageName+"List.html?"+this.projectId+"&"+this.projectName);
        }
        else
        {
            window.location.href=encodeURI(pageName+"?"+this.projectId+"&"+this.projectName);
        }

        // this.projectName=this.$refs.dataNum[index].dataset.name;
        // this.projectId=this.$rem[index].dataset.name;
        //将数据存储到全局变量Store中
        // this.$store.commit('setProjectName', this.projectName);
        // this.$store.commit('setProjectId', this.projectId);
        //读取全局变量Store的值
        // console.info(this.$store.state.projectName);
    }

    function jumpToProjectListPage() {
        window.location.href=`projectList.html`;
    }

    //跳转到“我的”
    function jumpToMessagePage() {
        window.location.href=encodeURI(`message.html?${this.projectId}&${this.projectName}`);
    }

    //跳转到“个人中心”
    function jumpToPersonalCenter(activeName) {
        window.location.href=encodeURI(`personalCenter.html?${this.projectId}&${this.projectName}&${activeName}`);
    }

    // //退出
    // function logout() {
    //     this.$api.post('/smMemberLoginOut.smhtml', this.getForm(), jsonObj => {
    //         localStorage.removeItem("memberName")
    //         localStorage.removeItem("headImagePath")
    //         localStorage.removeItem("firstLetter")
    //         localStorage.removeItem("email")
    //         localStorage.removeItem("memberId")
    //         localStorage.removeItem("phoneNumber")
    //         localStorage.removeItem("memberToken")
    //         window.location.href="login.html"
    //     },jsonObj => {
    //         this.$message.error(jsonObj.info);
    //     })
    // }

    //与我相关数量
    function getStatisticsCountForMe() {
        // let model = {
        //     interfaceVersion:19000101,
        // }
        // this.$api.post('/smStatisticsCountForMe.smhtml', model, jsonObj => {
        //     this.totalCount = jsonObj.totalCount;
        // },jsonObj => {
        //     // console.log(jsonObj);
        //     this.$message.error(jsonObj.info);
        // })
    }

    function getProductMemberDetailForHead() {
        let model = {
            interfaceVersion:19000101,
        }
        this.$api.post('/smProductMemberDetailForHead.smhtml', model, jsonObj => {
            this.isBuyPackage = jsonObj.isBuyPackage
            this.productName = jsonObj.productName
            this.validDateMaxStr = jsonObj.validDateMaxStr
            this.isInValid = jsonObj.isInValid
        },jsonObj => {
            this.$message.error(jsonObj.info);
        })
    }

    function jumpToIndexPay() {
        this.stopBubble()
        window.location.href=`index.html?1`
    }
</script>

<style scoped lang="less">
    .cs-head{
        text-align: center;
        background: #2b3a48;
        color: #fff;
        height: 60px;
        line-height: 60px;
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        z-index: 20;
    }
    .head-logo{
        float: left;
        padding-left: 45px;
        text-align: left;
        box-sizing: border-box;
    }
    .head-logo img{
        margin-top: -5px;
        display: inline-block;
        cursor: pointer;
    }
    .head-user{
        float: right;
        text-align: right;
    }
    .head-pro{
        display: inline-block;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    }
    .sel-pro{
        display: inline-block;
        font-size: 16px;
        margin-right: 30px;
    }
    .sel-pro .el-icon-arrow-down{
        margin-left: 10px;
    }
    .btn-add{
        display: inline-block;
        background: #405a73;
        font-size: 15px;
        padding: 5px 10px;
        border-radius: 4px;
        cursor: pointer;
        line-height: 1;
    }
    .btn-add:hover{
        background: #1ab3a6;
    }
    .btn-add i{
        font-size: 12px;
        margin-right: 5px;
    }
    .btn-add i,.btn-add span{
        vertical-align: middle;
    }
    .info,.person{
        display: inline-block;
        cursor: pointer;
        padding: 0 20px;
        vertical-align: top;
    }
    .info .num{
        background: #ee5f5f;
        display: inline-block;
        font-size: 12px;
        border-radius: 10px;
        padding: 1px 3px;
        line-height: 1;
    }
    .info:hover{
        background: #192a39;
    }
    .info .text{
        margin: 0 7px;
    }
    .line{
        display: inline-block;
        color: #6b757f;
        font-size: 20px;
    }
    .person{
        font-size: 16px;
        position: relative;
    }
    .person:hover{
        background: #29b6b0;
    }
    .top-user{
        position: relative;
    }
    .top-user .icon{
        position: absolute;
        bottom: 15px;
        left: 20px;
    }
    .user-img{
        display: inline-block;
        text-align: center;
        width: 30px;
        height: 30px;
        line-height: 30px;
        border-radius: 50%;
        color: #2b3a48;
        font-weight: bold;
        margin-right: 15px;
    }
    .user-img.bg{
        background: #c6cfd5;
    }
    .person-list,.pro-wrap{
        position: absolute;
        top: 70px;
        right: 20px;
        z-index: 30;
        color: #555;
        white-space: nowrap;
        background: #fff;
        border: 1px solid #cccccc;
        border-radius: 4px;
        line-height: 40px;
        text-align: left;
        padding: 10px 0;
    }
    .pro-content,.person-content{
        display: none;
    }
    .person:hover .person-content,.sel-pro:hover .pro-content{
        display: block;
    }
    .person-list img{
        width: 16px;
        font-size: 14px;
        margin: 0 20px;
    }
    .person-list span{
        vertical-align: middle;
    }
    .person-list li{
        padding: 5px 20px 5px 0;
    }
    .person-list li:hover,.pro-list li:hover{
        background: rgba(212,240,239,0.4);
    }
    .sel-pro{
        position: relative;
        font-size: 14px;
        cursor: pointer;
    }
    .pro-wrap{
        right: -30px;
        width: 290px;
        overflow-x: hidden;
    }
    .pro-list li{
        padding: 0 10px;
        cursor: pointer;
    }
    .pro-input{
        padding: 5px 10px;
    }
    .pro-list{
        overflow-y: auto;
        max-height: 350px;
        width: 310px;
    }
    .arrow{
        position: absolute;
        z-index: 1;
        top: 35px;
        right: 0px;
        width: 100%;
        text-align: right;
    }
    .person-content .arrow{
        left: 0px;
        padding-left: 30px;
        text-align: left;
    }
    /*下拉菜单*/
    .person-list .user-img{
        width: 50px;
        height: 50px;
        line-height: 50px;
    }
    .person-list .bg{
        background: #c6edff;
    }
    .drop-user{
        position: relative;
        display: inline-block;
        vertical-align: middle;
        margin-left: 15px;
    }
    .drop-user .icon{
        position: absolute;
        right: 0;
        bottom: 0;
    }
    .drop-user-info{
        display: inline-block;
        line-height: 23px;
        vertical-align: middle;
    }
    .drop-user-info .name{
        font-size: 15px;
        font-weight: bold;
    }
    .drop-user-info .email{
        color: #828291;
        font-size: 13px;
    }
    .person-list .icon-pro{
        width: 24px;
        margin: 0 16px;
    }
    .drop-pro{
        display: inline-block;
        line-height: 23px;
        vertical-align: middle;
        color: #552507;
    }
    .drop-pro .name{
        font-weight: bold;
    }
    .drop-pro .time{
        font-size: 12px;
        font-weight: bold;
    }
    .drop-btn{
        display: inline-block;
        vertical-align: middle;
        width: 70px;
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 900;
        text-align: center;
        color: #552507;
        background-color: #f6dcaf;
        cursor: pointer;
        margin-left: 30px;
    }
    /*语言*/
    .info-language{
        padding-right: 10px;
    }
    .language{
        width: 100px;
        display: inline-block;
    }
    .about-me{
        padding: 0 10px;
        span{
            color: #fff;
            margin-left: 5px;
        }
    }
</style>
<style>
    .language input{
        background: transparent;
        color: #fff;
        border: none;
    }
    .language .el-input__prefix,.language .el-input__suffix{
        top: -3px;
    }
</style>
